'use es6';

import { CONVERSATION_SESSION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const ConversationSession = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated('CRM:ILSFilters:ActivityFilters'),
  objectTypeId: CONVERSATION_SESSION_TYPE_ID,
  referenceObjectType: 'CONVERSATION_SESSION_PROPERTIES'
});
export default ConversationSession;